class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.nextUrl = this.dataset.nextUrl;
    this.productsLoadingType = this.dataset.productsLoadingType;
    this.sectionToRender = this.dataset.sectionToRender;
    this.requestPending = false;

    if (this.productsLoadingType === "load_more_button") this.loadMoreButton = this.querySelector("#infinite-scroll-load-more-button");
  }

  connectedCallback() {
    if (this.productsLoadingType === "load_more_button") {
      this.loadMoreButton.addEventListener("click", this.fecthNextProducts.bind(this));
    }
    if (this.productsLoadingType === "infinite_scroll") {
      const handleIntersection = (entries, observer) => {
        if (this.nextUrl && entries[0].isIntersecting === true) {
          this.fecthNextProducts();
        } else if (!this.nextUrl && entries[0].isIntersecting === true) {
          observer.unobserve(this);
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 500px 0px" }).observe(this);
    }
  }

  async fecthNextProducts() {
    if (this.requestPending) return;
    this.requestPending = true;
    this.setVisualPendingState();
    const response = await fetchURL(`${this.nextUrl}&sections=${this.sectionToRender}`, "text");
    const parsedResponse = JSON.parse(response)[this.sectionToRender];
    this.insertNewProducts(parsedResponse);
    this.setVisualPendingState();
    this.requestPending = false;
  }

  insertNewProducts(response) {
    const nextSection = new DOMParser().parseFromString(response, "text/html");
    const nextItems = nextSection.getElementById("product-grid").innerHTML;
    const actualProductGrid = document.getElementById("product-grid");
    actualProductGrid.insertAdjacentHTML("beforeend", nextItems);
    const updatedSentinel = nextSection.querySelector("#infinite-scroll-sentinel");
    this.nextUrl = updatedSentinel.dataset.nextUrl;

    if (this.loadMoreButton && !this.nextUrl) this.loadMoreButton.setAttribute("disabled", "true");

    // dispatch event when new products are added
    window.dispatchEvent(new CustomEvent(window.customEvents.infiniteScrollTrigger));
  }

  setVisualPendingState() {
    this.classList.toggle("infinite-scroll--loading");
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
